import React, { useState } from "react"
import { Button } from "@mui/material"
import Input from "../../components/Input"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import FactCheckIcon from "@mui/icons-material/FactCheck"
import { useModal } from "../../hooks/useModal"
import { LoadingButton } from "@mui/lab"
import { NavLink } from "react-router-dom"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import servo from "../../services/servo"
import moment from "moment"
import "./DatosOrdenServicio.css"

const DatosOrdenServicio = ({
  formDetails,
  setformDetails,
  empresa,
  setEmpresa,
  checklist,
  setChecklist,
  guardarDatosOrdenServicio,
  loadingButton
}) => {
  const permisoCheck = "ordenServicios"
  const [permiso] = useLocalStorage("permiso", null)
  const { setContainerModal, setOpen } = useModal()
  const [loading, setLoading] = useState(false)

  const handleVisibilityClick = async () => {
    setLoading(true)
    try {
      const res = await servo.get(
        "checklists?expand=datoschecklists.carros.empresa,datoschecklists.empresas,datoschecklists.areas,gasolinachecklists.notas"
      )
      const validDataList = Array.isArray(res?.cuerpo?.resultado)
        ? res.cuerpo.resultado
        : []


      const modalContent = (
        <div style={{ textAlign: "center" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#157CC1", color: "#FFFFFF" }}>
                <th style={{ padding: "10px" }}>Fecha</th>
                <th style={{ padding: "10px" }}>Placas</th>
                <th style={{ padding: "10px" }}>Económico</th>
                <th style={{ padding: "10px" }}>Empresa</th>
                <th style={{ padding: "10px" }}>Proyecto</th>
              </tr>
            </thead>
            <tbody>
              {validDataList.map((e, i) => (
                <tr
                  key={i}
                  style={{
                    backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#D9D9D9"
                  }}
                  onClick={() => {
                    setEmpresa(e.datoschecklists?.carros?.empresa || null)
                    setChecklist({
                      idChecklist: e.idChecklist,
                      economico: e.datoschecklists?.carros?.economico || "",
                      placas: e.datoschecklists?.carros?.placas || "",
                      modelo: e.datoschecklists?.carros?.modelo || "",
                      marca: e.datoschecklists?.carros?.marca || "",
                      year: e.datoschecklists?.carros?.year || "",
                      vin: e.datoschecklists?.carros?.vin || "",
                      fechaPoliza: e.datoschecklists?.carros?.fechaPoliza || "",
                      tarjetaCirculacion:
                        e.datoschecklists?.carros?.tarjetaCirculacion || "",
                      nombreEmpresa: e.datoschecklists?.carros?.empresa?.nombre || "",
                      proyecto: e.datoschecklists?.areas?.nombre || "",
                      notas: e.gasolinachecklists?.notas || "",
                      kilometraje: e.gasolinachecklists?.kilometraje ?? "",
                      gasolina: e.gasolinachecklists?.gasolina ?? ""
                    })
                    setOpen(false) // Cierra el modal después de seleccionar
                  }}
                >
                  <td style={{ padding: "10px", textAlign: "center" }}>
                    {e.creado}
                  </td>
                  <td style={{ padding: "10px", textAlign: "center" }}>
                    {e.datoschecklists?.carros?.placas}
                  </td>
                  <td style={{ padding: "10px", textAlign: "center" }}>
                    {e.datoschecklists?.carros?.economico}
                  </td>
                  <td style={{ padding: "10px", textAlign: "center" }}>
                    {e.datoschecklists?.carros?.empresa?.nombre}
                  </td>
                  <td style={{ padding: "10px", textAlign: "center" }}>
                    {e.datoschecklists?.areas?.nombre}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )

      setContainerModal(modalContent)
      setOpen(true) // Abre el modal
    } catch (error) {
      console.error("Error al cargar los checklists:", error)
    } finally {
      setLoading(false)
    }
  }

  const camposVehiculo = [
    ["economico", "No. Económico"],
    ["vin", "Número de chasis"],
    ["placas", "Placas"],
    ["modelo", "Modelo"],
    ["marca", "Marca"],
    ["year", "Año"],
    ["fechaPoliza", "Fecha de Póliza"],
    ["tarjetaCirculacion", "Tarjeta de Circulación"],
    ["kilometraje", "Kilometraje"],
    ["gasolina", "% Gasolina"],
    ["nombreEmpresa", "Empresa dueña del vehículo"],
    ["proyecto", "Proyecto"]
  ]

  return (
    <section className="service-order-data">
      <div className="service-order-data__toolbar">
        {(permiso?.[permisoCheck] & 1) === 1 && (
          <NavLink exact to={"/" + permisoCheck}>«Volver</NavLink>
        )}
        <Button
          variant="outlined"
          startIcon={<FactCheckIcon />}
          onClick={handleVisibilityClick}
          disabled={loading || loadingButton}
        >
          Seleccionar checklist
        </Button>
      </div>
      <div className="service-order-data__panel">
        <div className="service-order-data__general">
          <div className="service-order-data__field service-order-data__company">
            <AutocompleteDeluxe
              labelToShow="Empresa que pagará"
              labelProp="nombre"
              idProp="idEmpresa"
              nombre="empresas"
              dato={empresa}
              setDato={setEmpresa}
            />
          </div>
          <div className="service-order-data__field">
            <Input
              disabled
              typeInput="form"
              nombre="Fecha de Solicitud"
              valor={formDetails?.fechaSolicitud
                ? moment(formDetails.fechaSolicitud).format("DD/MM/YYYY")
                : ""}
            />
          </div>
          <div className="service-order-data__discount">
            <div className="service-order-data__field service-order-data__toggle">
              <Input
                typeInput="boolean"
                nombre="¿Aplica descuento?"
                valor={!!formDetails?.aplicaDescuento}
                setValor={(checked) => {
                  setformDetails((prev) => ({
                    ...prev,
                    aplicaDescuento: checked,
                    descuento: checked ? (prev?.descuento ?? 0) : 0
                  }))
                }}
              />
            </div>
            <div className="service-order-data__field">
              <Input
                typeInput="form"
                typeFormat="percent"
                nombre="Descuento (%)"
                placeholder="0 - 100"
                valor={formDetails?.descuento ?? ""}
                disabled={!formDetails?.aplicaDescuento}
                onChange={(e) => {
                  const value = e.target.value
                  setformDetails((prev) => ({
                    ...prev,
                    descuento: value === "" ? "" : parseInt(value, 10)
                  }))
                }}
              />
            </div>
          </div>
        </div>
        <div className="service-order-data__vehicle">
          {camposVehiculo.map(([key, label]) => (
            <div className="service-order-data__field" key={key}>
              <Input typeInput="form" nombre={label} valor={checklist[key]} disabled />
            </div>
          ))}
        </div>
        <div className="service-order-data__actions">
          <LoadingButton
            variant="contained"
            loading={loadingButton}
            onClick={guardarDatosOrdenServicio}
          >
            GUARDAR
          </LoadingButton>
        </div>
      </div>
    </section>
  )
}
export default DatosOrdenServicio
